import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

const PrivateRoute = ({ component: Component, user, isRedirect, redirect, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      (isRedirect(user.isAuth) ? (
        <Redirect
          to={{
            pathname: redirect,
            state: { from: props.location },
          }}
        />
      ) : (
        <Component {...props} />
      ))
    }
  />
);

const mapStateToProps = state => ({
  user: state.user,
});

export default withRouter(connect(mapStateToProps)(PrivateRoute));



// WEBPACK FOOTER //
// ./src/routes/PrivateRoute.js